<template>
  <div>
    <div>
      <SectionHeader :text="$t('history.discography')" />
      <transition name="load">
        <h2 v-if="!data" class="text-center">
          <Loading />
        </h2>
        <div v-if="data" id="history-content">
          <div v-for="item in data" :key="item.text" class="disco-wrapper">
            <div class="disco-image"></div>
            <div class="disco-text">{{ item.text }}</div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Loading from "../Loading";
import SectionHeader from "../SectionHeader";

export default {
  name: "FirstPage",
  components: {
    Loading,
    SectionHeader
  },
  data() {
    return {
      data: null
    };
  },
  mounted() {
    this.$http
      .get("discography/")
      .then(response => (this.data = response.data));
  }
};
</script>

<style scoped>
.load-enter-active,
.load-leave-active {
  transition: 1s;
}

.load-leave-active {
  position: absolute;
}

.load-enter {
  opacity: 0;
}

.load-leave-to {
  opacity: 0;
}

.disco-wrapper {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 30px 50px 30px 34px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid #d0d0d0;
  border-bottom: 0;
}

.disco-wrapper:last-child {
  border-bottom: 1px solid #d0d0d0;
}

.disco-image {
  width: 50px;
  height: 50px;
  margin-right: 43px;
  background-image: url("https://uploads-ssl.webflow.com/5bd2228c30a329044478d158/5bfac293cc98ddface7a4279_album.svg");
  background-position: 50% 50%;
  background-size: contain;
  background-repeat: no-repeat;
}

.disco-text {
  font-size: 1.4em;
  font-weight: 300;
}
</style>
